@if ($model() != null) {
    <form class="px-1" (ngSubmit)="onSubmit()" #flowObjectGatewayPaths="ngForm">
        <div class="scroll-wrapper styled-scrollbar px-1">
            <!-- Nome da Sequência A -->
            <div class="form-group ml-0" featureHint="flowObjectDetailsGatewayPaths|FirstGatewayPathName" featureHintHAlign="right">
                <label for="firstGatewayPathName">Nome da Sequência A</label>

                <input type="text" class="form-control" id="firstGatewayPathName" name="firstGatewayPathName" required
                       [ngModel]="$firstGatewayPathName()"
                       (change)="$firstGatewayPathName.set($event.target.value)"
                >
            </div>

            <!-- Nome da Sequência B -->
            <div class="form-group ml-0" featureHint="flowObjectDetailsGatewayPaths|SecondGatewayPathName" featureHintHAlign="right">
                <label for="secondGatewayPathName">Nome da Sequência B</label>

                <input type="text" class="form-control" id="secondGatewayPathName" name="secondGatewayPathName" required
                       [ngModel]="$secondGatewayPathName()"
                       (change)="$secondGatewayPathName.set($event.target.value)"
                >
            </div>

            <!-- Modo de Divisão do Fluxo -->
            <div class="form-group">
                <h5>Modo de Divisão do Fluxo</h5>
            </div>

            <!-- Seletor de modo -->
            <div class="mb-3" featureHint="flowObjectDetailsGatewayPaths|GatewayPathsDivisionMode" featureHintHAlign="right" featureHintVAlign="top" featureHintShowOn="right">
                <mat-radio-group class="division-mode" id="divisionMode" name="divisionMode" color="primary"
                                 [ngModel]="$divisionMode()"
                                 [required]="true"
                                 (ngModelChange)="divisionModeChange($event)"
                >
                    <mat-radio-button [value]="DivisionMode.Conditional">Condicional a partir do formulário</mat-radio-button>
                    <mat-radio-button [value]="DivisionMode.Deliberation">Por deliberação do usuário servidor</mat-radio-button>
                </mat-radio-group>
            </div>

            @if ($divisionMode() == DivisionMode.Conditional) {
                <!-- Condições para a Divisão do Fluxo -->
                <div class="form-group">
                    <h5>Condições para a Divisão do Fluxo</h5>
                </div>

                <!-- Info -->
                <div class="form-group">
                    <span>
                        O resultado da avaliação das condições abaixo determinará qual das Sequências de Tarefas
                        nomeadas acima será executada em seguida no Fluxo — caso o resultado seja <b>verdadeiro</b>,
                        a <b>Sequência A</b> será executada; caso contrário, a <b>Sequência B</b> será executada.
                    </span>
                </div>

                <!-- Condições -->
                <div class="form-group">
                    @for (condition of $conditions(); track condition; let i = $index) {
                        <div class="condition-row mb-2">
                            <!-- Campo do Formulário -->
                            <div class="form-group" featureHint="flowObjectDetailsGatewayPaths|FormField">
                                <label for="formField_{{i}}">Campo do Formulário</label>

                                <select class="form-control px-1" id="formField_{{i}}" name="formField_{{i}}" required
                                        [(ngModel)]="condition.formField"
                                        [matTooltip]="getFormFieldDescription(condition)"
                                >
                                    @for (option of $formFieldOptions(); track option) {
                                        <option [value]="option.value">{{option.description}}</option>
                                    }
                                </select>
                            </div>

                            <!-- Operador -->
                            <div class="form-group" featureHint="flowObjectDetailsGatewayPaths|RuleOperator">
                                <label for="ruleOperator_{{i}}">Operador</label>

                                <select class="form-control px-1" id="ruleOperator_{{i}}" name="ruleOperator_{{i}}"
                                        [(ngModel)]="condition.ruleOperator"
                                        [matTooltip]="getRuleOperatorDescription(condition)"
                                        (change)="ruleOperatorChange(condition)"
                                >
                                    @for (option of gatewayRuleOperatorOptions; track option) {
                                        <option [value]="option.value">{{option.description}}</option>
                                    }
                                </select>
                            </div>

                            <!-- Valor -->
                            <div class="form-group" featureHint="flowObjectDetailsGatewayPaths|ReferenceValue">
                                <label for="referenceValue_{{i}}">Valor</label>

                                @let ph1 = condition.ruleOperator <= GatewayRuleOperator.LessOrEqual
                                    ? '"10"'
                                    : condition.ruleOperator == GatewayRuleOperator.IsTrue
                                        ? '"true"'
                                        : condition.ruleOperator == GatewayRuleOperator.IsFalse
                                            ? '"false"'
                                            : condition.ruleOperator == GatewayRuleOperator.IsNull
                                                ? '"null"'
                                                : condition.ruleOperator == GatewayRuleOperator.IsNotNull
                                                    ? '"250"'
                                                    : condition.ruleOperator == GatewayRuleOperator.IsEmpty
                                                        ? '""'
                                                        : condition.ruleOperator == GatewayRuleOperator.IsNotEmpty
                                                            ? '"Opção A"'
                                                            : '"(termo a ser pesquisado)"';
                                <input type="text" class="form-control px-1" id="referenceValue_{{i}}" name="referenceValue_{{i}}"
                                       [(ngModel)]="condition.referenceValue"
                                       [matTooltip]="condition.referenceValue"
                                       [disabled]="condition.referenceValueDisabled"
                                       [placeholder]="ph1"
                                >
                            </div>

                            <!-- Remover Condição -->
                            <div class="form-group">
                                <span>&nbsp;</span>
                                <i class="fas fa-times-circle action remove" matTooltip="Remover condição" (click)="removeCondition(condition)" (keyDown)="removeCondition(condition)"></i>
                            </div>
                        </div>
                    }
                </div>

                <!-- Adicionar Condição -->
                <div class="form-group text-center">
                    <button type="button" class="btn btn-outline-success add-condition" (click)="addCondition()" (keyDown)="addCondition()">
                        <i class="fas fa-plus-circle mr-2"></i>
                        <span>Adicionar Condição</span>
                    </button>
                </div>

                <!-- Operador Lógico -->
                @if ($conditions().length > 1) {
                    <div class="form-group logical-operator-container ml-0 mb-3">
                        <span>Selecione o tipo de operador lógico a ser utilizado na avaliação de múltiplas condições:</span>

                        <mat-radio-group class="mb-2" id="isLogicalOperatorAnd" name="isLogicalOperatorAnd" color="primary"
                                         [ngModel]="$isLogicalOperatorAnd()"
                                         (ngModelChange)="$isLogicalOperatorAnd.set($event)"
                        >
                            <mat-radio-button [value]="true">E (AND)</mat-radio-button>
                            <div class="ml-4 mt-1">
                                O resultado da avaliação das condições acima será verdadeiro
                                se <strong>todas</strong> as condições forem verdadeiras.
                            </div>

                            <mat-radio-button class="mt-3" [value]="false">OU (OR)</mat-radio-button>
                            <div class="ml-4 mt-1">
                                O resultado da avaliação das condições acima será verdadeiro
                                se <strong>qualquer uma</strong> das condições for verdadeira.
                            </div>
                        </mat-radio-group>
                    </div>
                }
            }
        </div>

        <!-- Botões -->
        <div class="form-footer text-right mb-1">
            <hr class="mt-0" />

            <!-- ConfigSchema -->
            <div class="button-wrapper float-left ml-1" featureHint="flowObjectDetails|ConfigSchemaButton" featureHintVAlign="bottom" featureHintShowOn="right">
                <button type="button" class="btn btn-outline-secondary" (click)="showConfigSchema()">Editar código-fonte</button>
            </div>

            <!-- Cancelar -->
            <div class="button-wrapper mr-2" featureHint="flowObjectDetails|CancelButton" featureHintVAlign="bottom" featureHintShowOn="right">
                <button type="button" class="btn btn-outline-danger" (click)="closeForm()">Cancelar</button>
            </div>

            <!-- Salvar -->
            <div class="button-wrapper" featureHint="flowObjectDetails|SaveButton" featureHintVAlign="bottom" featureHintShowOn="right">
                <button type="submit" class="btn btn-outline-primary"
                        [disabled]="!flowObjectGatewayPaths.form.valid || $isReadOnlyMode()"
                >Salvar Rascunho</button>
            </div>
        </div>
    </form>

    <!-- Modal do ConfigSchema -->
    <ng-template #configSchemaRef>
        <i class="button fas fa-times close" matTooltip="Fechar" (click)="configSchemaDialog.close()"></i>

        <button type="button" class="button btn btn-primary" (click)="Utils.copyToClipboard(configSchemaEditorRef, copyInfoRef);">
            <i class="fas fa-copy mr-2"></i>
            <span>Copiar conteúdo</span>
        </button>

        <button type="button" class="button btn btn-outline-info info" #copyInfoRef><span>Conteúdo copiado!</span></button>
        <button type="button" class="button btn btn-outline-info info" #pasteInfoRef><span>Conteúdo colado!</span></button>

        <button type="button" class="button btn btn-success right" (click)="Utils.pasteFromClipboard(configSchemaEditorRef, pasteInfoRef)">
            <i class="fas fa-paste mr-2"></i>
            <span>Colar conteúdo</span>
        </button>

        <textarea class="schema-editor form-control styled-scrollbar" [ngModel]="$configSchemaFlat()" #configSchemaEditorRef></textarea>
    </ng-template>
}
